module.exports = __webpack_public_path__ + "static/about-88a99941fa677011441fdbf6bff24a02.png";